import { render, staticRenderFns } from "./ResponsivePaymentTable.vue?vue&type=template&id=571ba0d8&scoped=true&"
import script from "./ResponsivePaymentTable.vue?vue&type=script&lang=js&"
export * from "./ResponsivePaymentTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePaymentTable.vue?vue&type=style&index=0&id=571ba0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ba0d8",
  null
  
)

export default component.exports